// redux/selectors/conversationSelectors.ts
import { RootState } from "../../storeTypes";
import { createSelector } from "reselect";

// Select Unread Counts Selector ----------------------------------------------------------------
export const selectAllUnreadCounts = (state: RootState) =>
    state.conversation.unreadCounts;

export const selectTotalUnreadCount = createSelector(
  [(state: RootState) => state.conversation.unreadCounts],
  (unreadCounts) => Object.values(unreadCounts).reduce((sum, count) => sum + count, 0)
);

// Message Search --------------------------------------------------------------------------------
export const makeSelectMessageSearchResults = () =>
  createSelector(
    [
      (state: RootState) => state.conversation.searchResults,
      (_: RootState, dialogueSlug: string) => dialogueSlug,
    ],
    (searchResults, dialogueSlug) => searchResults?.[dialogueSlug] || []
  );

  
export const selectMessageSearchLoading = (state: RootState) =>
    state.conversation?.searchLoading;
  

export const selectMessageSearchError = (state: RootState) =>
    state.conversation?.searchError;


// Mark Selector ---------------------------------------------------------------------------------
export const selectDialogueMarkerBySlug = (dialogueSlug: string) => (state: RootState) =>
  state.conversation.userDialogueMarkers.find(marker => marker.dialogue_slug === dialogueSlug);



export const makeMessagesSelector = (dialogueSlug: string) =>
  createSelector(
    (state: RootState) => state.conversation.dialogues.find((d) => d.slug === dialogueSlug),
    (dialogue) => dialogue?.messages || []
  );



// Select all dialogues ------------------------------------------------------------------
export const selectAllDialogues = (state: RootState) => state.conversation.dialogues;

// Select dialogue by ID
export const selectDialogueBySlug = (dialogueSlug: string) => (state: RootState) =>
  state.conversation.dialogues.find((d) => d.slug === dialogueSlug) || null;


// Select loading state of conversation
export const selectConversationLoading = (state: RootState) => state.conversation.loading;

// Select error from conversation
export const selectConversationError = (state: RootState) => state.conversation.error;


// Select seenByUsers for a given message ID ---------------------------------------------
export const selectSeenByUsersForMessage = (messageId: number) => (state: RootState) =>
  state.conversation.seenByUsers[messageId];

// Select loading state for seenByUsers
export const selectSeenByLoading = (state: RootState) => state.conversation.seenByLoading;

// Select error state for seenByUsers
export const selectSeenByError = (state: RootState) => state.conversation.seenByError;